var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',{staticClass:"mb-2",attrs:{"cols":"12"}},[_c('span',{staticClass:"text-muted text-capitalize"},[_vm._v(_vm._s(_vm.$t('patrol_logs.unit_commander.no_filters')))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }